export default __webpack_public_path__ + "static/media/Wine-white.d95341e5.png";